export interface ICaseLawyer {
  id?: number;
  title?: string | null;
  aiChatId?: number | null;
  userId?: number | null;
  isDeleted?: boolean | null;
  step?: string | null;
}

export const defaultValue: Readonly<ICaseLawyer> = {
  isDeleted: false,
  aiChatId: null,
  step: null,
};
